<template>
   <div>
      <div class="cg-div">
         <FilterButton v-if="text" :label="text" @remove-filter="removeText()" />
         <template v-for="item in competencies">
            <FilterButton
               :key="`competency-${item.id}`"
               :label="item.label"
               @remove-filter="removeFilter('competency', item.id)"
            />
            <!-- Bug 223: insert space between buttons in group -->
            <slot> </slot>
         </template>
         <template v-for="item in levels">
            <FilterButton
               :key="`level=${item.id}`"
               :label="item.label"
               @remove-filter="removeFilter('level', item.id)"
            />
            <slot> </slot>
         </template>
         <template v-for="item in education">
            <FilterButton
               :key="`education-${item.id}`"
               :label="item.label"
               @remove-filter="removeFilter('education', item.id)"
            />
            <slot> </slot>
         </template>
         <template v-for="item in domains">
            <FilterButton
               :key="`domain-${item.id}`"
               :label="item.label"
               :class-name="item.className"
               @remove-filter="removeFilter('domain', item.id)"
            />
            <slot> </slot>
         </template>
      </div>
   </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import FilterButton from '@/components/FilterButton';

export default {
   name: 'FilterButtons',
   components: {
      FilterButton,
   },
   computed: {
      text: function () {
         console.log('freetext', this.$store.state.filters.freetext);
         return this.$store.state.filters.freetext;
      },
      competencies: function () {
         return this.$store.getters['filters/selectedCompetencies'];
      },
      levels: function () {
         return this.$store.getters['filters/selectedLevels'];
      },
      education: function () {
         return this.$store.getters['filters/selectedEducation'];
      },
      domains: function () {
         return this.$store.getters['filters/selectedDomains'];
      },
   },
   methods: {
      removeText: function () {
         // console.log('removeText');
         this.$store.commit('filters/setFreetext', {
            text: null,
         });
         this.$emit('do-search');
      },
      removeFilter: function (group, id) {
         this.$store.commit('filters/setCheckState', {
            group,
            id,
            val: false,
         });
         // check to see if all filters have been removed
         // including freetext
         // if so, then execute a filterGroups/clearAll style function
         if (
            !this.$store.state.filters.freetext &&
            this.competencies.length === 0 &&
            this.levels.length === 0 &&
            this.education.length === 0 &&
            this.domains.length === 0
         ) {
            // console.log('need to do a clear all!');
            this.$store.commit('filters/clearAll');
            this.$router.push({path: 'categories'});
         }
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterButtons.vue